function FeaturedAssignments() {
  return (
    <section className="featured-section">
      <div className="section-title-row">
        <div>
          <span className="section-kicker">
            Featured Opportunities
          </span>

          <h2>Find Your Next Assignment</h2>
        </div>

        <button className="outline-link-button" type="button">
          View All Assignments →
        </button>
      </div>

      <div className="assignment-card-grid">

        <article className="assignment-card">

          <div className="assignment-image assignment-image-one">
            <span className="assignment-badge urgent-badge">
              Urgent
            </span>
          </div>

          <div className="assignment-card-body">

            <span className="assignment-type">
              Registered Nurse
            </span>

            <h3>Emergency Department RN</h3>

            <div className="assignment-details">
              <span>📍 Barrie, Ontario</span>
              <span>🕒 Day & Night Shifts</span>
              <span>Contract Assignment</span>
            </div>

            <button type="button">
              View Assignment
            </button>

          </div>

        </article>

        <article className="assignment-card">

          <div className="assignment-image assignment-image-two">
            <span className="assignment-badge hiring-badge">
              Hiring
            </span>
          </div>

          <div className="assignment-card-body">

            <span className="assignment-type">
              Critical Care
            </span>

            <h3>ICU Registered Nurse</h3>

            <div className="assignment-details">
              <span>📍 Toronto, Ontario</span>
              <span>🕒 Night Shifts</span>
              <span>Full-time Contract</span>
            </div>

            <button type="button">
              View Assignment
            </button>

          </div>

        </article>

        <article className="assignment-card">

          <div className="assignment-image assignment-image-three">
            <span className="assignment-badge open-badge">
              Open
            </span>
          </div>

          <div className="assignment-card-body">

            <span className="assignment-type">
              Long-Term Care
            </span>

            <h3>Registered Practical Nurse</h3>

            <div className="assignment-details">
              <span>📍 Ottawa, Ontario</span>
              <span>🕒 Evening Shifts</span>
              <span>Temporary Placement</span>
            </div>

            <button type="button">
              View Assignment
            </button>

          </div>

        </article>

      </div>
    </section>
  );
}

export default FeaturedAssignments;